// extracted by mini-css-extract-plugin
module.exports = {"container":"Plan_container__2zpnX","priceMain":"Plan_priceMain__2A3B1","dec":"Plan_dec__2JDwN","hr":"Plan_hr__kb3ik","ul":"Plan_ul__31AXS"};